module.exports = __webpack_public_path__ + "img/ep-&-dosis.4d2b3712.jpg";